// @flow
import {CommonActions} from '@react-navigation/native';
import type {StripePaymentMethodType} from '../../../../../modules/Payment';
import Navigation from '../../../../../lib/navigation';
import type {NewPaymentMeanPageProps} from '../../NewPaymentMeanPage.props';
import HandleErrorService from '../../../../../lib/handleError';
import I18n from '../../../../../lib/i18n';
import WizzeeLog from '../../../../../lib/wizzeeLog';

export type StripePaymentCommonProps = NewPaymentMeanPageProps & {
  initStripePaymentMean: () => void,
};

export const onStripeSuccess = (
  stripePaymentMethod: StripePaymentMethodType,
  props: StripePaymentCommonProps,
) => {
  const bringBackTo = props.route.params?.bringBackTo;
  const isPaymentMeanUpdate = props.route.params?.isPaymentMeanUpdate;
  const paymentInfo = {type: 'STRIPE', stripePaymentMethod};
  props.addPaymentMean({paymentInfo, bringBackTo, isPaymentMeanUpdate});
};

export const onStripeError = (err: any) => {
  WizzeeLog.warn('NewPaymentMeanPage - Stripe', err);
  if (err.code === 'Canceled' || err.code === 'cancelled') {
    Navigation.dispatch(CommonActions.goBack());
    return 'cancelled';
  }
  const message = err.localizedMessage || err.message || I18n.t('SignUp.Payment.error');
  HandleErrorService.showToastError(message);
};
